// `convenios_module` gates the whole convênios module (credencial do membro,
// leitura/validação de QR code, anexo de comprovantes e insights). Seed
// migration: amsm-backend `hall/feature_flags/migrations/*_seed_convenios_module_flag.py`
// — off for every tenant until an administrator turns it on. The backend
// endpoints (`backend/convenios/api/...`) re-check this flag server-side, so
// this is a UI convenience, not the only gate.
export const CONVENIOS_MODULE_FLAG = 'convenios_module'

export const CONVENIO_CREDENCIAL_PATH = '/convenios/credencial'
export const CONVENIO_VALIDAR_USO_PATH = '/convenios/validar'
export const CONVENIO_USAGE_LIST_PATH = '/convenios/usos'
export const CONVENIO_MANAGEMENT_PATH = '/convenios/gestao'
export const CONVENIO_FORM_PATH = '/convenio/form'
export const CONVENIO_INSIGHTS_PATH = '/convenios/insights'

export const ATTACHMENT_TYPE_LABELS = {
  purchase_receipt: 'Nota de compra',
  card_receipt: 'Recibo de cartão',
}
